import questionnaireService from "./questionnaireService";

const questionnaireAnsServices = [
    ...questionnaireService
]

export default questionnaireAnsServices;